export default {
  title: "Supersede Issue",
  content:
    "<div>Are you sure you wish to supersede this <span class='text-info text-bold'>Issue</span>? <br><br>" +
    "This starts a pre-filled &quot;Raise Issue&quot; form on the <<span class='text-info text-bold'>Item</span>/" +
    "<span class='text-info text-bold'>Area</span>> containing exactly the same information, " +
    "<span class='text-info text-bold'>Step</span> responses and images as in this " +
    "<span class='text-info text-bold'>Issue</span>. <br><br>" +
    "This <span class='text-info text-bold'>Issue</span> will be irredeemably closed, any unhandled " +
    "<span class='text-info text-bold'>Corrective Work</span> will be rejected and the superseding " +
    "<span class='text-info text-bold'>Issue</span> will <span class='text-uppercase text-bold'>not</span> " +
    "automatically be added to a <span class='text-info text-bold'>Work Order</span>. <br><br>" +
    "<span class='text-italic'>If the creation of the superseding <span class='text-info text-bold'>Issue</span>" +
    " is abandoned, this Issue will remain as it is.</span></div>",
}
